export const SCANS = {
  TITLE: 'Escaneos',
  TABS: {
    APPSEC: 'AppSec',
  },
  APPSEC: {
    TITLE: 'Repositorios',
    ADD_REPOSITORY: 'Añadir repositorio',
    TABLE: {
      NAME: 'Repositorio',
      PROJECT_KEY: 'Clave de proyecto',
      SCM: 'SCM',
      CLONE_URL: 'URL de clonado',
      CREATED_AT: 'Creado',
      ACTIONS: 'Acciones',
      DELETE: 'Eliminar repositorio',
    },
    DIALOG: {
      TITLE: 'Añadir repositorio',
      NAME: 'Nombre del repositorio',
      NAME_PLACEHOLDER: 'mi-servicio',
      PROJECT_KEY: 'Clave de proyecto',
      PROJECT_KEY_PLACEHOLDER: 'Opcional',
      SCM: 'SCM',
      SCM_PLACEHOLDER: 'Selecciona SCM',
      CLONE_URL: 'URL de clonado (SSH)',
      CLONE_URL_PLACEHOLDER: 'git@host:proyecto/repo.git',
      CANCEL: 'Cancelar',
      SUBMIT: 'Añadir',
    },
    TOAST: {
      CREATED: 'Repositorio añadido',
      DELETED: 'Repositorio eliminado',
      CREATE_ERROR: 'Error al añadir el repositorio',
      DELETE_ERROR: 'Error al eliminar el repositorio',
      LOAD_ERROR: 'Error al cargar los repositorios',
    },
  },
}
